import React, { FC } from 'react';

export const ArrowDownSVG: FC<{clr: string, opacity?: string, onClick?: Function }> = ({ clr, opacity, onClick }) => {

    return (
        <svg width="16" height="16" fill={clr} onClick={() => onClick ? onClick() : false}viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity ? opacity : "0.3"}>
                <path d="M8 12.5L1 6L2 5L8 10.5L14 5L15 6L8 12.5Z" fill={clr}/>
            </g>
        </svg>
    )
}

import React, { FC } from 'react';

export const ArrowDownSVG: FC<{clr: string, opacity?: string, onClick?: Function }> = ({ clr, opacity, onClick }) => {

    return (
        <svg width="16" height="16" fill={clr} onClick={() => onClick ? onClick() : false}viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity ? opacity : "0.3"}>
                <path d="M8 12.5L1 6L2 5L8 10.5L14 5L15 6L8 12.5Z" fill={clr}/>
            </g>
        </svg>
    )
}

